import { useMutation } from '@apollo/client';
import { useSetRecoilState } from 'recoil';
import solicitationNotifications from '../../utils/solicitation-notification-helpers';
import { ARCHIVE_SOLICITATION, REACTIVATE_SOLICITATION } from '../../queries';
import { pageErrorNotifications } from '../../../../utilities/error-handling';

export const useSolicitationActions = ({ onCompleted } = {}) => {
  const setSolicitationNotification = useSetRecoilState(
    solicitationNotifications,
  );

  const [archiveSolicitation, { loading: archiveLoading }] = useMutation(
    ARCHIVE_SOLICITATION,
    {
      onError: (requestError) => {
        setSolicitationNotification(
          pageErrorNotifications(requestError, {
            id: 'ARCHIVE_SOLICITATION_BUTTON_FAILURE',
            message: `An error happened while archiving this solicitation. Please try again.`,
            type: 'error',
            closeable: true,
            showInModal: false,
          }),
        );
      },
      onCompleted: ({ archiveSolicitationById: sol }) => {
        setSolicitationNotification([
          {
            id: 'ARCHIVE_SOLICITATION_BUTTON_SUCCESS',
            message: `Solicitation ${sol.solicitationNumber} has been successfully archived.`,
            type: 'success',
            closeable: true,
            showOnHomePage: true,
          },
        ]);
        if (onCompleted) onCompleted();
      },
    },
  );

  const [reactivateSolicitation, { loading: reactivateLoading }] = useMutation(
    REACTIVATE_SOLICITATION,
    {
      onError: (requestError) => {
        setSolicitationNotification(
          pageErrorNotifications(requestError, {
            id: 'REACTIVATE_SOLICITATION_BUTTON_FAILURE',
            message: `An error happened while reactivating this solicitation. Please try again.`,
            type: 'error',
            closeable: true,
            showInModal: false,
          }),
        );
      },
      onCompleted: ({ reactivateSolicitationById: sol }) => {
        setSolicitationNotification([
          {
            id: 'REACTIVATE_SOLICITATION_BUTTON_SUCCESS',
            message: `Solicitation ${sol.solicitationNumber} has been successfully reactivated to ${sol.status} status.`,
            type: 'success',
            closeable: true,
            showOnHomePage: true,
          },
        ]);
        if (onCompleted) onCompleted();
      },
    },
  );

  return {
    archiveSolicitation,
    archiveLoading,
    reactivateSolicitation,
    reactivateLoading,
  };
};
